export const NEWS_CONSTS = {
    GET_NEWS_DATA:"SET_NEWS_DATA",
    GET_NEWS_BY_ID:"GET_NEWS_BY_ID",
    CREATE_NEWS_ITEM:"CREATE_NEWS_ITEM",
    UPDATE_NEWS_ITEM: "UPDATE_NEWS_ITEM",
    DELETE_NEWS_ITEM: "DELETE_NEWS_ITEM",
    UPDATE_NEWS_POSITIONS: "UPDATE_NEWS_POSITIONS",
};